import { useNavigate } from 'react-router-dom'
import { styled, useTheme } from '@mui/material'
import { Button } from '@carto/meridian-ds/components'
import useUserRoles from 'features/account/state/useUserRoles'
import { useAppDispatch } from 'app/state'
import { setCurrentConnection } from '../state/connectionsSlice'
import NoConnectionsTooltip from './NoConnectionsTooltip'

const StyledButton = styled(Button)(({ theme }) => ({
  whiteSpace: 'nowrap',
  cursor: 'pointer',
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    bottom: theme.spacing(3),
    right: theme.spacing(2),
    height: theme.spacing(6),
    borderRadius: theme.spacing(3),
    zIndex: 100,
    boxShadow: theme.shadows[6]
  }
}))

interface ConnectionsNewButtonProps {
  label: React.ReactNode
  icon?: React.ReactNode
  disabled?: boolean
  placement?: 'top' | 'bottom' | 'left' | 'right'
}

function ConnectionsNewButton({ label, icon, disabled, placement = 'left' }: ConnectionsNewButtonProps) {
  const { userHasEditionRole } = useUserRoles()
  const theme = useTheme()
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const createNewConnection = () => {
    dispatch(setCurrentConnection())
    navigate('/connections/create')
  }

  if (!userHasEditionRole) {
    return <></>
  }

  const button = (
    <StyledButton
      variant="contained"
      color="primary"
      startIcon={icon}
      size={theme.breakpoints.down('md') ? 'medium' : 'small'}
      onClick={createNewConnection}
      disabled={disabled}
      aria-disabled={disabled}
      aria-label={typeof label === 'string' ? label : undefined}
    >
      {label}
    </StyledButton>
  )

  return disabled ? <NoConnectionsTooltip button={button} placement={placement} /> : button
}

export default ConnectionsNewButton
